import { Primitive } from 'react-hook-form';

export function sortByOther<T extends Primitive>(
  other: T[],
  a: T,
  b: T,
): number {
  return other.indexOf(a) - other.indexOf(b);
}
